<script setup lang="ts">
import InputText from 'primevue/inputtext';

import Icon from 'lib/components/icon/Icon.vue';

import type {
  TreeSearchInputEmits,
  TreeSearchInputProps,
} from './TreeSearchInput.vue.d';

const props = defineProps<TreeSearchInputProps>();

const emit = defineEmits<TreeSearchInputEmits>();

const onKeydown = (event: KeyboardEvent): void => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};

const updateSearchModel = (query: string): void => {
  emit('update:modelValue', query);
};
</script>

<template>
  <div
    :class="[
      'relative w-full text-xs flex gap-1 py-[4.5px] px-2 items-center',
      'rounded ring-1 ring-inset ring-offset-0 ring-general-500 dark:!ring-white',
    ]"
    data-wv-name="tree-search-input"
  >
    <Icon
      class="w-4 h-4 shrink-0 grow-0 !text-general-400 dark:!text-white"
      icon="search"
    />

    <InputText
      v-focus
      :class="[
        'w-max grow h-auto !shadow-none !p-0 placeholder:text-general-200',
      ]"
      :model-value="props.modelValue"
      @input="updateSearchModel(($event.target as HTMLInputElement).value)"
      @keydown="onKeydown"
      autocomplete="off"
      placeholder="Search"
    />

    <Icon
      :class="[
        'text-md w-4 h-4 shrink-0 !text-general-400 dark:!text-white',
        { hidden: !props.modelValue },
      ]"
      @click="updateSearchModel('')"
      data-wv-section="reset-filter-icon"
      icon="close"
    />
  </div>
</template>
